import React from "react";
import { Table, Tag } from "antd";
import { STATUS_COLOR_MAP } from "../../hooks/useBotFilters";

/**
 * 假人列表表格 — 桌面端和移动端两套列定义
 */
const BotTable = ({ bots, loading, isMobile, onManage }) => {
  const desktopColumns = [
    {
      title: "假人名",
      dataIndex: "name",
      key: "name",
      width: 150,
      render: (text, record) => (
        <div className="botcontrol-name-cell">
          <div className="botcontrol-name">{text}</div>
          <div className="botcontrol-id">
            ID: {record.id.substring(0, 8)}...
          </div>
        </div>
      ),
    },
    {
      title: "服务器地址",
      dataIndex: "host",
      key: "host",
      width: 180,
      render: (text, record) => (
        <div className="botcontrol-ip">
          <i className="fas fa-server botcontrol-ip-icon"></i>
          {text}:{record.port}
        </div>
      ),
    },
    {
      title: "在线状态",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (status) => (
        <Tag color={STATUS_COLOR_MAP[status]} className="botcontrol-status-tag">
          {status}
        </Tag>
      ),
    },
    {
      title: "最后活动",
      dataIndex: "last_activity",
      key: "last_activity",
      width: 180,
      render: (text) => (
        <div className="botcontrol-last-active">
          <i className="far fa-clock"></i>
          {text}
        </div>
      ),
    },
    {
      title: "操作",
      key: "actions",
      width: 150,
      render: (_, record) => (
        <div className="botcontrol-actions">
          <button
            className="botcontrol-action-rect-btn"
            onClick={() => onManage(record)}
          >
            管理
          </button>
        </div>
      ),
    },
  ];

  const mobileColumns = [
    {
      title: "假人信息",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <div className="botcontrol-name-cell">
          <div className="botcontrol-name-mobile">
            <div className="botcontrol-name">{text}</div>
            <div className="botcontrol-mobile-info">
              <div className="botcontrol-mobile-ip">
                <i className="fas fa-server botcontrol-ip-icon"></i>
                {record.host}:{record.port}
              </div>
              <div className="botcontrol-mobile-status">
                <Tag
                  color={STATUS_COLOR_MAP[record.status]}
                  className="botcontrol-status-tag"
                >
                  {record.status}
                </Tag>
              </div>
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "操作",
      key: "actions",
      width: 120,
      render: (_, record) => (
        <div className="botcontrol-actions">
          <button
            className="botcontrol-action-rect-btn"
            onClick={() => onManage(record)}
          >
            管理
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="botcontrol-table-container">
      <Table
        columns={isMobile ? mobileColumns : desktopColumns}
        dataSource={bots}
        rowKey="id"
        pagination={{
          pageSize: isMobile ? 5 : 10,
          showSizeChanger: !isMobile,
          showQuickJumper: !isMobile,
          showTotal: (total) => `共 ${total} 条记录`,
        }}
        className="botcontrol-table"
        rowClassName="botcontrol-table-row"
        locale={{ emptyText: "暂无假人数据" }}
        loading={loading}
      />
    </div>
  );
};

export default BotTable;
